import React, {useCallback, useContext, useEffect, useState} from "react";
import {Page_getHomePage} from "../../network/api/mainPage.api";
import "./Home.css";
import {ErrorContext} from "../../components/GympinPagesProvider";
import {HomeSkeleton} from "../../components/skeletons";
import HomeEngine from "./HomeEngine";
import RetryView from "../../components/RetryView";
import {getStorage, setStorage} from "../../helper/storedData/useStorage";
import {getHomeLcpPreloadUrl} from "../../helper/utils";

const HOME_CACHE_KEY = "CACHE_HOME_MASTER_DATA";
const HOME_CACHE_TTL_SECONDS = 1800;
const HOME_FRESH_MS = 5 * 60 * 1000;

function homeCacheAgeMs() {
    try {
        const expiresAt = Number(localStorage.getItem(HOME_CACHE_KEY + "_expiresIn"));
        if (!expiresAt) return Number.POSITIVE_INFINITY;
        const savedAt = expiresAt - HOME_CACHE_TTL_SECONDS * 1000;
        return Date.now() - savedAt;
    } catch {
        return Number.POSITIVE_INFINITY;
    }
}

function Home() {
    const error = useContext(ErrorContext);
    const [data, setData] = useState(() => {
        try {
            const cached = getStorage(HOME_CACHE_KEY);
            if (cached) {
                const parsed = JSON.parse(cached);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    return parsed;
                }
            }
        } catch {
            // ignore cache parse errors
        }
        return [];
    });

    const getHome = useCallback((st) => {
        Page_getHomePage({SettingKey: st}).then(result => {
            const homeData = result?.data?.Data;
            setData(homeData);
            if (Array.isArray(homeData) && homeData.length > 0) {
                setStorage(HOME_CACHE_KEY, JSON.stringify(homeData), HOME_CACHE_TTL_SECONDS);
            }
        }).catch(e => {
            setData(prev => {
                if (Array.isArray(prev) && prev.length > 0) return prev;
                return null;
            });
            try {
                error.showError({message: e.response?.data?.Message || "خطا در دریافت اطلاعات"});
            } catch (f) {
                error.showError({message: "خطای نامشخص"});
            }
        });
    }, [error]);

    useEffect(() => {
        const cached = getStorage(HOME_CACHE_KEY);
        const fresh = Boolean(cached) && homeCacheAgeMs() < HOME_FRESH_MS;
        if (!fresh) {
            getHome("WEB_MASTER_HOMEPAGE_ID");
        }
    }, [getHome]);

    // پریلود تصویر LCP: اول بنر، در غیر این صورت اولین مدیا کاروسل
    useEffect(() => {
        const preloadUrl = getHomeLcpPreloadUrl(data);
        if (!preloadUrl) return;
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = preloadUrl;
        document.head.appendChild(link);
        return () => {
            try {
                document.head.removeChild(link);
            } catch {}
        };
    }, [data]);

    return (
        <>
            <title>وب اپلیکیشن جیم پین</title>
            {data === null && <RetryView onRetry={() => getHome("WEB_MASTER_HOMEPAGE_ID")} />}
            {data?.length < 1 && data !== null && <HomeSkeleton />}
            {data?.length > 0 && <HomeEngine items={data} />}
        </>
    );
}

export default Home;
